<template>
  <div class="loan-details">
    <LoanDetailsHero class="loan__hero" />

    <div class="loan__details grid-container" :class="{ full: !$device.isLarge }">
      <div class="grid-x">
        <Card class="basic-border">
          <CardSection :padding="false">
            <LoanDetailsMeta id="loanMeta" />

            <section id="loanDescriptionAndMap" class="grid-container">
              <MfiInfoMessage v-if="showMfiInfoMessage" class="margin-bottom-2"
                                                        :mfiInfoMessage="this.loan.mfiInfoMessage" />
              <div class="grid-x grid-padding-x">
                <div class="cell small-12 medium-7">
                  <LoanDetailsDescription id="loanDescription"
                                          :approved-at="$get(loan, 'approvedAt', null)"
                                          :description="$get(loan, 'description', '')"
                                          :entrepreneur-description="$get(loan, 'entrepreneurDescription', '')"
                                          :mfi-extra-info="$get(loan, 'mfiExtraInfo', '')" />
                </div>
                <div class="cell small-12 medium-5">
                  <img v-if="mapImage" :src="mapImage">
                </div>
              </div>
            </section>
          </CardSection>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { Card, CardSection } from '~/components/frontend/ui/card'
  import { getEntrepreneurName } from '~/modules/entrepreneurs/utils'
  import LoanDetailsDescription from '~/modules/loans/components/frontend/loan-details-description'
  import LoanDetailsHero from '~/modules/loans/components/frontend/loan-details-hero'
  import LoanDetailsMeta from '~/modules/loans/components/frontend/loan-details-meta'
  import i18n from './locales'
  import BasketTracker from '~/libs/tracking/analytics/trackers/basket'
  import Microloan from '~/modules/loans/entities/frontend/microloan'
  import MfiInfoMessage from '~/modules/loans/components/frontend/loan-mfi-info-message'

  export default {
    name: 'LoanDetails',
    i18n,
    components: {
      Card,
      CardSection,
      LoanDetailsDescription,
      LoanDetailsHero,
      LoanDetailsMeta,
      MfiInfoMessage,
    },
    computed: {
      ...mapGetters({
        loan: 'loans/current',
      }),
      mapImage () {
        return this.$get(this.loan, 'entrepreneur.mfi.image.medium', null)
      },
      showMfiInfoMessage () {
        let mfiInfoMessage = this.$get(this.loan, 'mfiInfoMessage', null)

        // Return false if there is no MFI info message.
        if (mfiInfoMessage === null) return false

        // If the info message is live and the loan status is either approved or
        // repaying, return true.
        return ['approved', 'repaying'].includes(this.loan.status) && mfiInfoMessage.live === true;
      },
    },
    methods: {
      getEntrepreneurName () {
        return getEntrepreneurName(this.loan.entrepreneur, {
          firstOnly: true,
          possessive: true,
        })
      },
    },
    created () {
      // Track loan view.
      const tracker = new BasketTracker()
      const microloan = new Microloan({
        loanId: this.loan.id,
        entrepreneurDisplayName: this.loan.entrepreneur.displayName,
        amount: 1500
      })
      tracker.itemDetails(microloan)
    },
  }
</script>

<style lang="scss" scoped>
  @import "~assets/scss/frontend/_colours";
  @import "~assets/scss/frontend/_settings";
  @import "~assets/scss/frontend/foundation/_settings";
  @import "~foundation-sites/scss/util/_breakpoint";

  .loan__hero {
    padding-bottom: 4rem;
  }
  .loan__details {
    transform: translateY(-4rem);
  }

  .loan-details {
    .card {
      border: {
        left: none;
        right: none;
      }

      @include breakpoint(large) {
        border: {
          left: $card-border;
          right: $card-border;
        }
      }
    }

    .loan-meta {
      padding-top: 1rem;
    }

    #loanDescriptionAndMap {
      @include breakpoint (medium) {
        border-top: $global-border;
        margin-top: 2rem;
        padding-top: 2rem;
      }

      .loan__map {
        padding-top: 1rem;
        padding-bottom: 2rem;
      }
    }

    .loan__sharing {
      background: $colour-magnolia-light;
      border: {
        top: $global-border;
      }
      padding: {
        bottom: 2rem;
        top: 2rem;
      }

      .share-cta {
        display: block;
        text-align: center;
        margin-bottom: 0.5rem;
      }
    }
  }
</style>
